module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Support Us")]), _vm._v(" "), _c('p', [_vm._v("I love doing this and want to do more.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The CR Market")]), _vm._v(" is a part of the "), _c('a', {
    attrs: {
      "href": "https://elementnova.com/",
      "target": "_blank"
    }
  }, [_vm._v("Element Nova")]), _vm._v(" Network.")]), _vm._v(" "), _c('p', [_vm._v("Through your support I'm able to keep this site up to date, work on new features, and build new products for gamers and fans.")]), _vm._v(" "), _c('p', [_vm._v("Please consider supporting The CR Market and Element Nova at our "), _c('a', {
    attrs: {
      "href": "https://ko-fi.com/elementnova/goal?g=7",
      "target": "_blank"
    }
  }, [_vm._v("Ko-Fi")]), _vm._v(" so we can continue creating great things for users like you.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-073ec331!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupportUs.vue
// module id = 753
// module chunks = 0